export default __webpack_public_path__ + "static/media/expiryContacts.44e7183c.svg";